let initialState =
{
    client: {
        items: [
            {
                name: 'Messages',
                link: 'messages',
            },

            {
                name: 'Contacts',
                link: 'contacts',

            },
            {
                name: 'News',
                link: 'news',

            },

        ]
    },
    manager: {
        items: [


            {
                name: 'Settings',
                link: 'settings',


            },
            {
                name: 'Clients',
                link: 'clients',

            },

            {
                name: 'Products',
                link: 'products',


            },
        ]
    },

    admin: {
        items: [

            {
                name: 'Managers',
                link: 'managers',


            },
            // {
            //     name: 'Settings',
            //     link: 'settings',


            // },
            {
                name: 'Clients',
                link: 'clients',

            },

            {
                name: 'Products',
                link: 'products',


            },
        ]
    },

    current: {
        items: []
    },
}


export type NavMenuStateType = typeof initialState


//ACION CREATORS
// export const actionsNavmenu = {
//     setAuthUserData: (role: UserType | null, isAuth: boolean = false) =>
//         ({ type: 'SP/AUTH/SET_USER_DATA', authUser, isAuth } as const),
    
// }




const navMenuReducer = (state: NavMenuStateType = initialState, action: any): NavMenuStateType => {
    switch (action.type) {
        case 'SP/AUTH/SET_USER_DATA':
            let result = state
            if (action.authUser) {
                if (action.authUser.role) {

                    let role = action.authUser.role as 'client' | 'manager' | 'admin'

                    if (role === 'client' || role ===  'manager' || role ===  'admin' ) {
                      
                        return {
                            ...state, current: {
                                // @ts-ignore
                                ...state.current, items: state[role].items
                            }
                        }
                    } else{
                        return state
                    }


                }
            }
            break;

        default:
            break;
    }



    return state
}

export default navMenuReducer